import { DOCUMENT } from 'entities/user/module'

import RUFlag from 'shared/icons/flags/ru_flag.svg'
import TRFlag from 'shared/icons/flags/tr_flag.svg'
import UAEFlag from 'shared/icons/flags/uae_flag.svg'
import WhatsAppIcon from 'shared/icons/socialLinks/whatsapp_icon.svg'
import KGFlag from 'shared/images/Flag.png'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Props } from 'shared/ui/contact-block'

export const WHATSAPP_NUMBER = '996990644464' //был временным '996559039093'

export const WHATSAPP_NUMBER_TOUR = '996559039093'

export const MAX_LENGTH_CLOSE_CIRCLE = 10

export const MAX_COUNT_DIFFICULT_ROUTE = 4

export const MAX_YEARS_DURATIONS = 100

export const MIN_SEAT_EXCURSION = 1

export const MIN_MPLUS_PRICE = 500

export const ONE_SECOND_TIMER = 1000

export const AVAILABLE_ID_PASSPORT = ['KG', 'RU']

export const AVAILABLE_CYRILLIC_INPUT = ['russia']

export const errorBorder = '1px solid #EC1212'
export const defaultBorder = '1px solid transparent'

export const SHOW_INN_FIELD_INSURANCE = ['398']

export const COUNT_MONTH_MPLUS = 3

export const DAYS_MPLUS = [1, 5, 10, 15, 20]

export const CASHBACK_VALUE = 7

export const isShowingMplus = true

export const isShowingBonus = false

export const YANDEX_PLUS_LINK = 'https://ya.cc/mtkg'

export const YANDEX_PLUS_DETAIL = 3

export type sourceAggregator = 1 | 2
// source => 1 === My agent
// source => 2 === Bookit

export const DEV_PHONE_NUMBERS = [
  '+996500418495', // Инсан
  '+996550905404', // Элиза
  '+996779028037', // Султан
  '+996550346895', // Айдар
  '+996550082233', // Эдиль
  '+996773426979', // Эркин
  '+996555272226', // Евгений байке,
  '+996706331160', //Аделина
  '+996505410410', // Талант
]

export const LIST_ALLOW_DATA = ['Russian Federation']

export enum TYPE_DRAWER {
  FROM = 'from',
  TO = 'to',
  CALENDAR = 'calendar',
  LEVEL_CLASS_N_COUNT = 'level_class_n_count',
  FILTER = 'filter',
  AIRLINES = 'airlines',
  AIRPORTS = 'airports',
  TIMER = 'TIMER',
}

export enum TYPE_AGE {
  ADULTS = 'adult',
  CHILDREN = 'child',
  INFANTS_WITHOUT_SEAT = 'infant',
  // INFANTS_WITH_SEAT = 'infants_with_place',
}

export enum TYPE_AGE_BEKET {
  ADULTS = 'adult',
  CHILDREN = 'child',
}

export enum TYPE_BAGGAGE {
  EMPTY = 'no_baggage',
  HAND_BAGGAGE = 'cbaggage',
  SUITCASE = 'baggage',
  ALL_OPTIONS = '',
}

export enum TYPE_TRANSFERS {
  WITHOUT = '0',
  ONE = '1',
  TWO = '2',
  ANY = '',
}

export const MAX_COUNT = 8

export const MAX_COUNT_BEKET = 5

export enum ADDITIONAL_SERVICE_STATUS {
  PENDING = 'PENDING',
  PAID = 'PAID',
  REJECTED = 'REJECTED',
  WAITING = 'WAITING',
}

export enum APPEAL_STATUS {
  PENDING = 'PENDING',
  PAID = 'PAID',
  REJECTED = 'REJECTED',
  WAITING = 'WAITING',
}

export enum REQUEST_STATUS {
  WORKING = 'IN_PROGRESS',
  AVIA = 'AWAITING_PARTNER',
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  CANCELLED = 'CANCELLED',
}

export enum ADDITIONAL_SERVICE {
  WORKING = 'IN_PROGRESS',
  CLOSED = 'CLOSED',
  APPROVED = 'APPROVED',
  PAID = 'PAID',
}

export const LIST_WORKING_STATUS = [
  REQUEST_STATUS.AVIA,
  REQUEST_STATUS.WORKING,
  REQUEST_STATUS.OPEN,
]

export enum TYPE_APPELS {
  ADDITIONAL_SERVICE = 'ADDITIONAL_SERVICE',
  REFUND = 'TICKET_REFUND',
  EXCHANGE = 'TICKET_TRADE',
  OTHER = 'OTHER',
}

export const WH_LINK = 'https://wa.me/'
export const GM_LINK = 'mailto:Support@mtravel.kg'

export const LIST_CONTACTS: Props[] = [
  {
    image: WhatsAppIcon,
    name: 'WhatsApp',
    link: WH_LINK + WHATSAPP_NUMBER,
    id: 'wh-0',
  },
  // { image: GmailIcon, name: "Gmail", link: GM_LINK, id: "gm-0" },
]

export const FAILED_NAMES = [
  'NAME',
  'LOL',
  'REGISTRATIONS',
  'RESERVATION',
  'FAMILIYA',
  'IMYA',
  'OTCHESTVO',
  'GROUP',
  'GRUP',
  'FIRSTNAME',
  'LASTNAME',
  'QWERTY',
  'ASDASD',
  'QWASD',
  'ASDFGHJ',
  'TEST',
  'FXSRY',
  'TEST',
  'TESTOV',
  'TESTOVICH',
  'ASDASD',
]

export const DomesticAirLines = [
  'FRU',
  'OSS',
  'JBD',
  'TZB',
  'TZI',
  'KRV',
  'IKG',
  'TLG',
  'BSZ',
  'IKU',
  'KRH',
  'KZM',
] //ВВЛ

export const ID_AVAILABLE_COUNTRIES_ADULT = [
  'TAS', // UZ
  'ABA',
  'DYR',
  'AAQ',
  'ARH',
  'ASF',
  'BAX',
  'EGO',
  'BQS',
  'BTK',
  'BZK',
  'VRI',
  'VVO',
  'OGZ',
  'VOG',
  'VOZ',
  'GRV',
  'SVX',
  'IKT',
  'KZN',
  'KGD',
  'KLF',
  'KEJ',
  'KRR',
  'KJA',
  'KRO',
  'URS',
  'LPK',
  'GDX',
  'MQF',
  'MCX',
  'MRV',
  'VKO',
  'DME',
  'ZIA',
  'SVO',
  'MMK',
  'NAL',
  'NJC',
  'NBC',
  'GOJ',
  'NOZ',
  'OVB',
  'NSK',
  'OMS',
  'REN',
  'OSW',
  'PEE',
  'PES',
  'PKC',
  'PVS',
  'PKV',
  'ROV',
  'KUF',
  'LED',
  'SKX',
  'GSV',
  'SIP',
  'AER',
  'STW',
  'SGC',
  'SCW',
  'TOF',
  'TJM',
  'UUD',
  'ULV',
  'ULY',
  'UFA',
  'KHV',
  'HMA',
  'CSY',
  'CEK',
  'CEE',
  'HTA',
  'ESL',
  'UUS',
  'YKS',
  'IAR', // RU
  'SCO',
  'АКХ',
  'ALA',
  'TSE',
  'GUW',
  'BXY',
  'BHХ',
  'BXJ',
  'DZN',
  'KGF',
  'KOV',
  'KSN',
  'KZO',
  'PWQ',
  'PPK',
  'PLX',
  'TDK',
  'DMB',
  'URA',
  'UKK',
  'CIT', // KZ
].concat(DomesticAirLines)

export const ID_AVAILABLE_COUNTRIES_CHILD = [
  'FRU',
  'OSS',
  'KRH', // KG
]

export const LIST_UNAVAILABLE_EMAILS = ['', 'email@email.com']

export const DataPopular = [
  {
    cityName: 'bishkek',
    countryName: 'kyrgyzstan',
    cityIataCode: 'FRU',
    image: KGFlag,
  },
  {
    cityName: 'osh',
    countryName: 'kyrgyzstan',
    cityIataCode: 'OSS',
    image: KGFlag,
  },
  {
    cityName: 'moscow',
    countryName: 'russia',
    cityIataCode: 'MOW',
    image: RUFlag,
  },
  {
    cityName: 'saint_petersburg',
    countryName: 'russia',
    cityIataCode: 'LED',
    image: RUFlag,
  },
  {
    cityName: 'novosibirsk',
    countryName: 'russia',
    cityIataCode: 'OVB',
    image: RUFlag,
  },
  {
    cityName: 'istanbul',
    countryName: 'turkey',
    cityIataCode: 'IST',
    image: TRFlag,
  },
  {
    cityName: 'antalya',
    countryName: 'turkey',
    cityIataCode: 'AYT',
    image: TRFlag,
  },
  {
    cityName: 'dubai',
    countryName: 'UAE',
    cityIataCode: 'DXB',
    image: UAEFlag,
  },
]

export enum SEARCH_TICKET {
  OPTIMAL = 'OPTIMAL',
  FASTEST = 'FASTEST',
  CHEAPEST = 'CHEAPEST',
  PROMO = 'PROMO',
}

export const TypesGender = {
  male: {
    name: 'male',
    key: 'male',
    icon: AllIcons.AVATAR_MAN,
  },
  female: {
    name: 'female',
    key: 'female',
    icon: AllIcons.AVATAR_WOMAN,
  },
}

export const TypesGenderList = Object.keys(TypesGender)?.map((key) => ({
  name: TypesGender[key as keyof typeof TypesGender].name,
  icon: TypesGender[key as keyof typeof TypesGender].icon,
  key: key,
}))

export type GenderTypes = keyof typeof TypesGender

export const ProfileTypes = {
  PASS: {
    name: 'id_passport',
    key: 'PASS',
    documentType: DOCUMENT.ID,
  },
  INT: {
    name: 'passport',
    key: 'INT',
    documentType: DOCUMENT.PASSPORT,
  },
}

export const ProfileTypesList = Object.keys(ProfileTypes)?.map((key) => ({
  name: ProfileTypes[key as keyof typeof ProfileTypes].name,
  key: key,
}))

export type IProfileTypes = keyof typeof ProfileTypes

export const TariffBeket = {
  child: {
    name: 'beket.child_tariff',
    key: 'child',
  },
  adult: {
    name: 'purchase_page.adults_count',
    key: 'adult',
  },
}

export const TariffBeketList = Object.keys(TariffBeket)?.map((key) => ({
  name: TariffBeket[key as keyof typeof TariffBeket].name,
  value: key,
}))

export type TariffBeketListType = keyof typeof TariffBeket

export const BeketTransportType = {
  VAN: {
    name: 'beket.van',
    key: 'van',
  },
  BUS: {
    name: 'beket.bus',
    key: 'bus',
  },
}

export const TicketClass = {
  // a: {
  //   key: 'a',
  //   name: 'all_class',
  //   value: 'a',
  // },
  e: {
    key: 'e',
    name: 'economy',
    value: 'e',
    secondaryKey: 'a',
  },
  b: {
    key: 'b',
    name: 'business',
    value: 'b',
  },
  // w: {
  //   key: 'w',
  //   name: 'comfort',
  //   value: 'w',
  // },
  // f: {
  //   key: 'f',
  //   name: 'first_class',
  //   value: 'f',
  // },
}

export const TicketClassList = Object.keys(TicketClass)?.map((key) => ({
  ...TicketClass[key as keyof typeof TicketClass],
  name: TicketClass[key as keyof typeof TicketClass].name,
}))

export type TicketClassTypes = keyof typeof TicketClass

export const StatusPurchase = {
  CREATED: {
    key: 'CREATED',
    color: 'rgba(18, 153, 88, 1)',
    background: 'rgba(238, 248, 244, 1)',
    name: 'status_names.created',
  },
  PAID: {
    key: 'PAID',
    color: 'rgba(18, 153, 88, 1)',
    background: 'rgba(238, 248, 244, 1)',
    name: 'status_names.paid',
  }, // Куплен
  PENDING: {
    key: 'PENDING',
    color: 'rgba(250, 114, 7, 1)',
    background: 'rgba(255, 249, 217, 1)',
    name: 'status_names.pending',
  }, //В обработке
  USED: {
    key: 'USED',
    color: 'rgba(116, 116, 118, 1)',
    background: 'rgba(241, 241, 242, 1)',
    name: 'status_names.used',
  }, //Просрочен
  REFUNDED: {
    key: 'REFUNDED',
    color: 'rgb(250, 114, 7, 1)',
    background: 'rgba(255, 249, 217, 1)',
    name: 'status_names.refunded',
  }, //Обменен
  REISSUED: {
    key: 'REISSUED',
    color: 'rgba(236, 18, 18, 1)',
    background: 'rgba(254, 237, 237, 1)',
    name: 'status_names.reissued',
  }, //Возвращен
  BOOKED: {
    key: 'BOOKED',
    color: 'rgba(250, 114, 7, 1)',
    background: 'rgba(255, 241, 230, 1)',
    name: 'status_names.booked',
  }, //Забронирован
  CANCELLED: {
    key: 'CANCELLED',
    color: 'rgba(236, 18, 18, 1)',
    background: 'rgba(254, 237, 237, 1)',
    name: 'status_names.cancelled',
  },
  IN_PROGRESS: {
    key: 'IN_PROGRESS',
    color: 'rgba(250, 114, 7, 1)',
    background: 'rgba(255, 249, 217, 1)',
    name: 'status_names.in_progress',
  }, //В обработке по оплате
}

export const TypesStatusPurchaseList = Object.keys(StatusPurchase)?.map(
  (key) => ({
    name: StatusPurchase[key as keyof typeof StatusPurchase].name,
    key: key,
  }),
)

export type StatusStatusPurchaseTypes = keyof typeof StatusPurchase

export const StatusPurchaseExcursion = {
  PAID: {
    key: 'PAID',
    color: 'rgba(18, 153, 88, 1)',
    background: 'rgba(238, 248, 244, 1)',
    name: 'status_names_excursion.paid',
  },
  CREATED: {
    key: 'CREATED',
    color: 'rgba(250, 114, 7, 1)',
    background: 'rgba(255, 249, 217, 1)',
    name: 'status_names_excursion.created',
  },
  PENDING: {
    key: 'PENDING',
    color: 'rgba(250, 114, 7, 1)',
    background: 'rgba(255, 249, 217, 1)',
    name: 'status_names.pending',
  },
}

export const StatusPurchaseExcursionList = Object.keys(
  StatusPurchaseExcursion,
)?.map((key) => ({
  name: StatusPurchaseExcursion[key as keyof typeof StatusPurchaseExcursion]
    .name,
  key: key,
}))

export type StatusPurchaseExcursionTypes = keyof typeof StatusPurchaseExcursion

export const StatusBeketPurchase = {
  CREATED: {
    key: 'CREATED',
    color: 'rgba(18, 153, 88, 1)',
    background: 'rgba(238, 248, 244, 1)',
    name: 'status_names.created',
  },
  PAID: {
    key: 'PAID',
    color: 'rgba(18, 153, 88, 1)',
    background: 'rgba(238, 248, 244, 1)',
    name: 'status_names.paid',
  }, // Куплен
  REFUNDED: {
    key: 'REFUNDED',
    color: 'rgb(250, 114, 7, 1)',
    background: 'rgba(255, 249, 217, 1)',
    name: 'status_names.refunded',
  }, //Обменен
  BOOKED: {
    key: 'BOOKED',
    color: 'rgba(18, 153, 88, 1)',
    background: 'rgba(238, 248, 244, 1)',
    name: 'status_names.booked',
  }, //Забронирован
  CANCELLED: {
    key: 'CANCELLED',
    color: 'rgba(236, 18, 18, 1)',
    background: 'rgba(254, 237, 237, 1)',
    name: 'status_names.cancelled',
  },
}

export const TypesStatusBeketPurchaseList = Object.keys(StatusPurchase)?.map(
  (key) => ({
    name: StatusPurchase[key as keyof typeof StatusPurchase].name,
    key: key,
  }),
)

export type StatusBeketPurchaseTypes = keyof typeof StatusPurchase

export const StatusToursPurchase = {
  CREATED: {
    key: 'CREATED',
    color: 'rgba(18, 153, 88, 1)',
    background: 'rgba(238, 248, 244, 1)',
    name: 'status_names.created',
  },
  PAID: {
    key: 'PAID',
    color: 'rgba(18, 153, 88, 1)',
    background: 'rgba(238, 248, 244, 1)',
    name: 'status_names.paid',
  },
  IN_PROGRESS: {
    key: 'IN_PROGRESS',
    color: 'rgba(18, 153, 88, 1)',
    background: 'rgba(238, 248, 244, 1)',
    name: 'status_names.decorated',
  },
  CONFIRMED: {
    key: 'CONFIRMED',
    color: 'rgba(250, 114, 7, 1)',
    background: 'rgba(255, 249, 217, 1)',
    name: 'status_names.request_send',
  },
  CLOSED: {
    key: 'CLOSED',
    color: 'rgba(236, 18, 18, 1)',
    background: 'rgba(254, 237, 237, 1)',
    name: 'status_names.closed',
  },
  PENDING: {
    key: 'PENDING',
    color: 'rgba(250, 114, 7, 1)',
    background: 'rgba(255, 249, 217, 1)',
    name: 'status_names.pending',
  },
}

export const TypesStatusToursPurchaseList = Object.keys(
  StatusToursPurchase,
)?.map((key) => ({
  name: StatusToursPurchase[key as keyof typeof StatusToursPurchase].name,
  key: key,
}))

export type StatusToursPurchaseTypes = keyof typeof StatusToursPurchase

export const TypesCurrencyTextSymbol = {
  KGS: {
    name: '\u20c0',
    key: 'KGS',
  },
  USD: {
    name: '$',
    key: 'USD',
  },
  EUR: {
    name: '€',
    key: 'EUR',
  },
} as const

export const TypesCurrencyTextSymbolList = Object.keys(
  TypesCurrencyTextSymbol,
)?.map((key) => ({
  name: TypesCurrencyTextSymbol[key as keyof typeof TypesCurrencyTextSymbol]
    .name,
  key: key,
}))

export type CurrencyTextSymbolTypes = keyof typeof TypesCurrencyTextSymbol

export const TypeRefundTicketAvia = {
  Refunded: {
    name: 'only_refund_ticket',
    key: 'Refunded',
    value: true,
  },
  NotRefunded: {
    name: 'non_refundable_tickets_only',
    key: 'NotRefunded',
    value: false,
  },
  All: {
    name: 'all_tickets',
    key: 'All',
    value: null,
  },
}

export const TypeRefundTicketAviaList = Object.keys(TypeRefundTicketAvia)?.map(
  (key) => ({
    ...TypeRefundTicketAvia[key as keyof typeof TypeRefundTicketAvia],
    key: key,
  }),
)

export type TypeRefundTicketAviaTypes = keyof typeof TypeRefundTicketAvia

export const UserMplusStatus = {
  WAITING: {
    key: 'WAITING',
    availableMplus: false,
  },
  DENIED: {
    key: 'DENIED',
    availableMplus: false,
  },
  DENY: {
    key: 'DENY',
    availableMplus: false,
  },
  IN_PROCESS: {
    key: 'IN_PROCESS',
    availableMplus: false,
  },
  ACTIVE: {
    key: 'ACTIVE',
    availableMplus: true,
  },
  OFFLINE: {
    key: 'OFFLINE',
    availableMplus: false,
  },
  TO_ISSUE: {
    key: 'TO_ISSUE',
    availableMplus: false,
  },
  CLOSED: {
    key: 'CLOSED',
    availableMplus: false,
  },
  NO_REQUESTS: {
    key: 'NO_REQUESTS',
    availableMplus: false,
  },
}

export type UserMplusStatusTypes = keyof typeof UserMplusStatus

export const ActiveMplusStatuses = [UserMplusStatus.ACTIVE.key] as string[]

export const ListCitizenshipAllowLatinByAge = [
  {
    password: DOCUMENT.BIRTH_CERTIFICATE,
    citizenship: AVAILABLE_ID_PASSPORT[1],
    ages: [
      TYPE_AGE.INFANTS_WITHOUT_SEAT,
      // TYPE_AGE.INFANTS_WITH_SEAT,
    ] as string[],
  },
] as const

export const SeatBeketStatuses = [UserMplusStatus.ACTIVE.key] as string[]

export const EventKey = {
  football: {
    key: 'football',
    promoId: '1d345fec-bb41-46d3-98e6-54fdd4350e2b',
  },
}

export const StringForGenerateToken =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

export const UrlShare =
  'https://app.mbank.kg/web/service/mtravel/redirect?redirectUrl='

export const PriceCertificate = 10000

export const CertificateDeepLink =
  'https://app.mbank.kg/native/rewards_promotion'

export const ShareKeys = {
  hotel: 'hotel',
  bus: 'bus',
  avia: 'ticket',
  kyrgyzstan: 'kyrgyzstan_search',
  umrah: 'umrah',
  excursion: 'excursion',
}

export const CurrencySom = '\u20C0' // &#8384;
